<template>
  <view class="container" :class="{ 'popup-container': pageFrom === 'popup' }">
    <view v-if="pageFrom !== 'popup'" class="header-area a-w-100% a-h-320 a-relative" :class="{ 'is-app': isApp }">
      <TwCircleBack v-if="isApp" class="icon-back" @back="onBackClick" />
      <image class="a-w-100%" src="https://image.ceekee.com/app/public/img_moreoftentopimg.png" mode="widthFix"></image>
      <view class="a-w-100% a-h-88 a-absolute a-left-0 a-bottom-54 a-flex a-jc-sb a-ai-c a-p-0-20">
        <view class="a-fs-50 a-lh-50 a-fw-600 a-c-#fff">我的常用</view>
        <view class="gost-btn" @click="switchMode">
          <view class="tripwise_outline icon-setting_outline a-fs-28 a-mr-4"></view>
          <view>{{ isEdit ? '退出管理' : '常用管理' }}</view>
        </view>
      </view>
    </view>
    <!-- 主体内容区域 -->
    <view class="content-view">
      <view v-if="pageFrom === 'popup'" class="a-fs-36 a-lh-36 a-fw-600 a-c-#141414 a-p-30-30-0-30">我的常用</view>
      <!-- 城市选择 -->
      <view class="city-wrapper" v-if="cities.length > 0">
        <TwScrollX>
          <view class="city-inner-wrapper">
            <view
              v-for="item in cities"
              class="city-tag"
              :key="item.cityName"
              :class="{ active: activeCity === item.cityName }"
              @click="changeCities(item)"
            >
              {{ '去' + item.cityName }}
              <image
                v-if="activeCity === item.cityName"
                class="tag-arrow"
                src="https://image.ceekee.com/app/public/img_tabbottom.png"
                mode="heightFix"
              ></image>
            </view>
          </view>
        </TwScrollX>
      </view>
      <!-- 常用标签 -->
      <view class="commonly-tags-wrapper">
        <view class="offen-used-tag">
          <view class="a-p-0-10 a-flex a-ai-c a-w-100%">
            <view
              v-for="(item, index) in categories"
              :key="item.productType"
              class="category-tag-wrapper a-flex a-ai-c"
            >
              <view
                class="category-tag"
                :class="{ active: activeCategory === item.productType }"
                @click="changeCategory(item)"
              >
                <view class="category-icon" :class="[`bg-${item.productType}`]">
                  <image class="a-w-28 a-h-28" :src="item.icon"></image>
                </view>
                {{ item.name }}
              </view>
              <view v-if="showLine(index)" class="line"></view>
            </view>
          </view>
        </view>
      </view>
      <!-- 酒店 -->
      <HotelView
        v-if="activeCategory === 1 && !isLoading"
        :list="list"
        :isEdit="isEdit"
        :pageFrom="pageFrom"
        :showMoreControl="controlPath ? showMoreControl[controlPath] : { offen: false, book: false, see: false }"
        @delete="handleDelete"
        @add="handleAdd"
        @changeMoreControl="changeMoreControl"
        @jumpToCommonlyUsed="jumpToCommonlyUsed"
        @goIndexLine="goIndexLine"
      />
      <!-- 飞机 -->
      <FlightView
        v-if="activeCategory === 5 && !isLoading"
        :list="list"
        :isEdit="isEdit"
        :pageFrom="pageFrom"
        :showMoreControl="controlPath ? showMoreControl[controlPath] : { offen: false, book: false, see: false }"
        @delete="handleDelete"
        @add="handleAdd"
        @changeMoreControl="changeMoreControl"
        @jumpToCommonlyUsed="jumpToCommonlyUsed"
        @goIndexLine="goIndexLine"
      />
      <!-- 火车 -->
      <TrainView
        v-if="activeCategory === 6 && !isLoading"
        :list="list"
        :isEdit="isEdit"
        :pageFrom="pageFrom"
        :showMoreControl="controlPath ? showMoreControl[controlPath] : { offen: false, book: false, see: false }"
        @delete="handleDelete"
        @add="handleAdd"
        @changeMoreControl="changeMoreControl"
        @jumpToCommonlyUsed="jumpToCommonlyUsed"
        @goIndexLine="goIndexLine"
      />
      <!-- 地点 -->
      <CarView
        v-if="activeCategory === 7 && !isLoading"
        :list="list"
        :isEdit="isEdit"
        :pageFrom="pageFrom"
        :showMoreControl="controlPath ? showMoreControl[controlPath] : { offen: false, book: false, see: false }"
        @delete="handleDelete"
        @add="handleAdd"
        @changeMoreControl="changeMoreControl"
        @openDialog="openOperationDialog"
        @jumpToCommonlyUsed="jumpToCommonlyUsed"
        @goIndexLine="goIndexLine"
      />
      <CommonlyUsedSkeleton v-if="isLoading" />
    </view>
    <TwTabbar v-if="pageFrom !== 'popup'" selected="''" />

    <OperationDialog
      :open="openOperation"
      :activeCarItem="activeCarItem"
      :activeCityItem="activeCityItem"
      @delete="handleDelete"
      @change="(show) => (openOperation = show)"
    />
  </view>
</template>

<script>
import TwCircleBack from '@/componentsV3/common/tw-circle-back/index.vue';
import TwScrollX from '@/componentsV3/common/tw-scroll-x/index.vue';
import HotelView from './components/HotelView.vue';
import FlightView from './components/FlightView.vue';
import TrainView from './components/TrainView.vue';
import CarView from './components/CarView.vue';
import OperationDialog from './components/OperationDialog.vue';
import {
  frequentlyUsedCityList,
  frequentlyUsedBusinessList,
  frequentlyUsedBusinessDelete,
  frequentlyUsedBusinessEdit,
} from '@/api/platform/tripwise-m.js';
import { frequentlyUsedAdd } from '@/utils/bizcommon/frequentlyUsed.js';
import CommonlyUsedSkeleton from '@/componentsV3/biz/TwSkeleton/CommonlyUsed.vue';

export default {
  components: {
    TwCircleBack,
    TwScrollX,
    HotelView,
    FlightView,
    TrainView,
    CarView,
    OperationDialog,
    CommonlyUsedSkeleton,
  },
  props: {
    pageFrom: {
      type: String,
      default: 'page',
    },
  },
  data() {
    return {
      isApp: false,
      cities: [],
      activeCity: '',
      activeCityItem: null,
      categories: [
        { name: '酒店', productType: 1, icon: 'https://image.ceekee.com/app/home/index/icon_hotel.png' },
        { name: '机票', productType: 5, icon: 'https://image.ceekee.com/app/home/index/icon_flight.png' },
        { name: '高铁', productType: 6, icon: 'https://image.ceekee.com/app/home/index/icon_train.png' },
        { name: '用车', productType: 7, icon: 'https://image.ceekee.com/app/home/index/icon_car.png' },
      ],
      activeCategory: 1,
      positionCity: null,
      isEdit: false,
      openOperation: false,
      list: {
        frequentlyUsed: [],
        frequentlyBook: [],
        frequentlySaw: [],
      },
      showMoreControl: {},
      propsCityId: null,
      needMore: 0, // 页面初始化进来，是否需要默认展开更多
      activeCarItem: null, // 编辑的用车数据
      isLoading: true, // 常用列表是否正在加载
    };
  },
  onLoad(options) {
    // #ifdef APP-PLUS
    this.isApp = true;
    // #endif

    const { productType, cityId, needMore } = options;
    if (productType) {
      this.activeCategory = Number(productType);
    }
    if (cityId) {
      this.propsCityId = Number(cityId);
    }
    if (needMore) {
      this.needMore = Number(needMore);
    }

    uni.$on('editRemark', (params) => {
      this.$request({
        apiName: frequentlyUsedBusinessEdit,
        params,
      }).then((res) => {
        if (this.$app.GetResultState(res)) {
          this.$app.Toast('修改成功');
          this.openOperation = false;
          this.getCommonlyInfo();
        } else {
          this.$app.Toast(res.message);
        }
      });
    });
    uni.$on('selectCommonlyPlace', (item) => {
      this.$request({
        apiName: frequentlyUsedBusinessEdit,
        params: {
          arrivalCity: item.cityCode,
          arrivalCityName: item.city,
          arrivalInfo: item.address,
          mainId: this.activeCarItem && this.activeCarItem.id,
          productName: item.name,
          productType: 7,
          lat: item.location.split(',')[1],
          lng: item.location.split(',')[0],
        },
      }).then((res) => {
        if (this.$app.GetResultState(res)) {
          this.$app.Toast('修改成功');
          this.openOperation = false;
          this.getCommonlyInfo();
        } else {
          this.$app.Toast(res.message);
        }
      });
    });
  },
  onUnload() {
    uni.$off('editRemark');
  },
  onShow() {
    // 获取列表信息
    this.getPageData();
  },
  mounted() {
    if (this.pageFrom === 'popup') {
      setTimeout(() => {
        this.getPageData();
      }, 500);
    }
    // 添加常用后，点击物理回退、刷新列表
    uni.$on('refreshCommonlyUsedList', () => {
      // 获取列表信息
      this.getPageData();
    });
  },
  beforeDestroy() {
    uni.$off('refreshCommonlyUsedList');
  },
  onPullDownRefresh() {
    this.getPageData();
  },
  computed: {
    controlPath() {
      if (this.activeCityItem && this.activeCityItem.cityId && this.activeCategory) {
        return `show-${this.activeCityItem.cityId}-${this.activeCategory}`;
      } else {
        return '';
      }
    },
    showLine() {
      return (index) => {
        const findActiveIndex = this.categories.findIndex((item) => item.productType === this.activeCategory);
        return index !== findActiveIndex && index !== findActiveIndex - 1 && index < this.categories.length - 1;
      };
    },
  },
  methods: {
    jumpToCommonlyUsed() {
      uni.navigateTo({
        url: `/pages/index3.0/offenUsed/index?productType=${this.activeCategory}&cityId=${this.activeCityItem.cityId}&needMore=1`,
      });
    },
    handleAdd(item) {
      frequentlyUsedAdd(item).then(() => {
        this.getCommonlyInfo();
      });
    },
    handleDelete(item) {
      this.$request({
        apiName: frequentlyUsedBusinessDelete,
        params: { mainId: item.id, productType: this.activeCategory },
      }).then((res) => {
        if (this.$app.GetResultState(res)) {
          if (this.list.frequentlyUsed.length > 1) {
            this.getCommonlyInfo();
          } else {
            this.getPageData();
          }
          this.$app.Toast('已移除');
        } else {
          this.$app.Toast(res.message);
        }
      });
    },
    changeMoreControl(type) {
      this.showMoreControl[this.controlPath][type] = true;
    },
    getPageData() {
      this.isLoading = true;
      this.getCityList().then((res) => {
        this.cities = res;
        // 如果外部跳转进来设置了城市，高亮当前城市
        if (this.propsCityId) {
          const findCityItem = this.cities.find((item) => item.cityId === this.propsCityId);
          if (findCityItem) {
            this.activeCity = findCityItem.cityName;
            this.activeCityItem = findCityItem;
          } else {
            this.activeCity = this.cities.length > 0 ? this.cities[0].cityName : '';
            this.activeCityItem = this.cities.length > 0 ? this.cities[0] : null;
          }
        } else {
          const findCityItem = this.cities.find((item) => item.cityName === this.activeCity);
          if (findCityItem) {
            this.activeCity = findCityItem.cityName;
            this.activeCityItem = findCityItem;
          } else {
            this.activeCity = this.cities.length > 0 ? this.cities[0].cityName : '';
            this.activeCityItem = this.cities.length > 0 ? this.cities[0] : null;
          }
        }
        // 获取列表信息
        if (this.activeCity) {
          this.getCommonlyInfo();
        } else {
          this.list = {
            frequentlyUsed: [],
            frequentlyBook: [],
            frequentlySaw: [],
          };
          uni.stopPullDownRefresh();
          this.isLoading = false;
        }
      });
    },
    getCityList() {
      return new Promise((resolve) => {
        this.$request({ apiName: frequentlyUsedCityList }).then((res) => {
          if (this.$app.GetResultState(res)) {
            resolve(res.data || []);
          } else {
            this.$app.Toast(res.message);
            resolve([]);
          }
        });
      });
    },
    getCommonlyInfo() {
      this.isLoading = true;
      if (!this.activeCityItem) {
        this.isLoading = false;
        uni.stopPullDownRefresh();
        return;
      }
      this.$request({
        apiName: frequentlyUsedBusinessList,
        params: {
          cityCode: this.activeCityItem ? this.activeCityItem.cityCode : '',
          cityId: this.activeCityItem ? this.activeCityItem.cityId : '',
          productType: this.activeCategory,
        },
      })
        .then((res) => {
          if (this.$app.GetResultState(res)) {
            this.list = {
              frequentlyUsed: res.data.frequentlyUsed || [],
              frequentlyBook: res.data.frequentlyBook || [],
              frequentlySaw: res.data.frequentlySaw || [],
            };
            if (!this.showMoreControl[this.controlPath]) {
              this.$set(this.showMoreControl, this.controlPath, {
                offen: false,
                book: false,
                see: false,
              });
            }
            if (this.needMore) {
              this.changeMoreControl('offen');
            }
          } else {
            this.$app.Toast(res.message);
          }
          uni.stopPullDownRefresh();
        })
        .finally(() => {
          uni.stopPullDownRefresh();
          this.isLoading = false;
        });
    },
    openOperationDialog(item) {
      this.activeCarItem = item;
      this.openOperation = true;
    },
    switchMode() {
      this.isEdit = !this.isEdit;
    },
    onBackClick() {
      uni.navigateBack();
    },
    changeCities(item) {
      this.activeCity = item.cityName;
      this.activeCityItem = item;
      // 获取列表信息
      this.getCommonlyInfo();
    },
    changeCategory(item) {
      this.activeCategory = item.productType;
      // 获取列表信息
      this.getCommonlyInfo();
    },
    goIndexLine() {
      let url = '';
      if (this.activeCategory === 1) {
        url = '/pages/product3.0/hotel/index/index?productType=1';
      } else if (this.activeCategory === 5) {
        url = '/pages/product3.0/integratedTraffic/index?productType=5';
      } else if (this.activeCategory === 6) {
        url = '/pages/product3.0/integratedTraffic/index?productType=6';
      } else if (this.activeCategory === 7) {
        url = '/pages/product3.0/car/index/index';
      }
      if (url) {
        uni.navigateTo({
          url: url,
        });
      }
    },
  },
};
</script>

<style lang="less" scoped scoped>
.container {
  width: 100%;
  height: 100vh;
  &.popup-container {
    height: auto;
  }
  .header-area {
    margin-top: calc(var(--status-bar-height) - 88rpx);
    &.is-app {
      margin-top: 0;
    }
  }
}
.icon-back {
  position: fixed;
  left: 20rpx;
  top: calc(14rpx + var(--status-bar-height));
  z-index: 10;
  background-color: rgba(255, 255, 255, 1);
  color: #141414;
}
.gost-btn {
  width: 184rpx;
  height: 60rpx;
  border-radius: 40rpx;
  background: rgba(0, 0, 0, 0.2);
  display: flex;
  align-items: center;
  padding: 0 20rpx;
  font-size: 28rpx;
  font-weight: 500;
  line-height: 28rpx;
  color: #fff;
}
.content-view {
  width: 100%;
  min-height: calc(100% - 202rpx - var(--status-bar-height));
  position: absolute;
  padding-bottom: 140rpx;
  background-color: #ededed;
  margin-top: -30rpx;
  border-radius: 32rpx 32rpx 0 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
}
.city-tag {
  height: 68rpx;
  border-radius: 60rpx;
  display: inline-flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 20rpx 30rpx;
  background: #f7f9fb;
  font-size: 28rpx;
  line-height: 28rpx;
  color: #595959;
  margin-right: 16rpx;
  position: relative;
  white-space: nowrap;
  &.active {
    background: #fff;
    font-weight: 500;
    color: #141414;
    .icon-locate_outline {
      font-weight: 500;
      color: #141414;
    }
  }
  .tag-arrow {
    position: absolute !important;
    height: 11rpx;
    bottom: -11rpx;
    left: 50%;
    transform: translateX(-50%);
  }
}
.offen-used-tag {
  width: 100%;
  height: 80rpx;
  border-radius: 12rpx;
  box-shadow: 0px 12rpx 20rpx 0px rgba(0, 0, 0, 0.02);
  background-color: #fff;
  display: flex;
  align-items: center;
}
.category-tag-wrapper {
  flex: 1;
  &:first-child .category-tag {
    margin-left: 0;
  }
  &:last-child .category-tag {
    margin-right: 0;
  }
}
.category-tag {
  width: 100%;
  height: 60rpx;
  border-radius: 6rpx;
  padding: 12rpx 20rpx;
  border: 2rpx solid #fff;
  color: #595959;
  font-size: 24rpx;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-wrap: nowrap;
  white-space: nowrap;
  margin: 0 4rpx;
  &.active {
    border: 2rpx solid #057bff;
    background: #edf6ff;
    font-weight: 600;
    color: #141414;
    margin: 0;
  }
  .category-icon {
    flex-shrink: 0;
    width: 28rpx;
    height: 28rpx;
    border-radius: 100%;
    margin-right: 4rpx;
    &.bg-1 {
      background: linear-gradient(117deg, #ffac8c 14%, #f6635b 88%);
    }
    &.bg-5 {
      background: linear-gradient(240deg, #8dc0f1 14%, #4a86f8 87%);
    }
    &.bg-6 {
      background: linear-gradient(121deg, #6be1d2 9%, #4bbcae 87%);
    }
    &.bg-7 {
      background: linear-gradient(233deg, #f6bb7e 12%, #fa8b42 87%);
    }
  }
}
.line {
  width: 1rpx;
  height: 18rpx;
  background: #e4e4e4;
}
.city-wrapper {
  padding: 0 0 0 20rpx;
  margin-top: 30rpx;
}
.commonly-tags-wrapper {
  margin-top: 20rpx;
  padding: 0 20rpx;
}
.popup-container {
  .content-view {
    min-height: 1126rpx;
    position: inherit;
    padding-bottom: 30rpx;
    border-radius: 20rpx;
    margin-top: 0;
    display: flex;
    flex-direction: column;
  }
  .city-wrapper {
    padding-left: 30rpx;
    margin-top: 20rpx;
  }
  .empty-wrapper {
    position: inherit;
    margin: 20rpx 30rpx 0 30rpx;
    flex: 1;
  }
  .commonly-tags-wrapper {
    padding: 0 30rpx;
  }
  /deep/ .card-view {
    padding: 0 30rpx;
  }
  /deep/ .card {
    padding: 20rpx 30rpx 0 30rpx;
  }
  .city-tag:last-child {
    margin-right: 30rpx;
  }
}
.city-inner-wrapper {
  display: inline-flex;
  height: 79rpx;
  flex-wrap: nowrap;
}
/deep/ .empty-wrapper {
  flex: 1;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-color: #fff;
  border-radius: 12rpx;
  box-shadow: 0px 30rpx 30rpx 0px rgba(0, 0, 0, 0.02);
  padding: 80rpx 0;
}
/deep/ .card-view {
  margin-top: 20rpx;
  padding: 0 20rpx 0 20rpx;
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
